import request from '@/utils/request'

const url = '/home/home/'
const api = {
  getCateGroyList (data) {
    return request({
      url: url + 'getCateGroyList',
      method: 'post',
      data
    })
  },
  bannerList (data) {
    return request({
      url: url + 'bannerList',
      method: 'post',
      data
    })
  },
  getBrand (data) {
    return request({
      url: url + 'getBrand',
      method: 'post',
      data
    })
  },
  getFlash (data) {
    return request({
      url: url + 'getFlash',
      method: 'post',
      data
    })
  },
  getScene (data) {
    return request({
      url: url + 'getScene',
      method: 'post',
      data
    })
  },
  getHotGodds (data) {
    return request({
      url: url + 'getHotGoods',
      method: 'post',
      data
    })
  },
  getCategoryGoods (data) {
    return request({
      url: url + 'gatherList',
      method: 'post',
      data
    })
  },
  getChildGoods (data) {
    return request({
      url: url + 'getChildGoods',
      method: 'post',
      data
    })
  },
  uploadEnquiry (data) {
    return request({
      url: url + 'uploadEnquiry',
      method: 'post',
      data
    })
  },
  getRecommendGoods (data) {
    return request({
      url: url + 'getRecommendGoods',
      method: 'post',
      data
    })
  }
}
export default api



// WEBPACK FOOTER //
// ./src/api/index.js